// Vanilla JS implementation of nested form functionality
// Originally based on jquery-nested-form

window.NestedFormEvents = function() {
  this.addFields = this.addFields.bind(this);
  this.removeFields = this.removeFields.bind(this);
};

NestedFormEvents.prototype = {
  addFields: function(link) {
    // Setup
    var assoc = link.dataset.association; // Name of child
    var blueprint = document.getElementById(link.dataset.blueprintId);
    var content = blueprint.dataset.blueprint; // Fields template

    // Make the context correct by replacing <parents> with the generated ID
    // of each of the parent objects
    var closestFields = link.closest('.fields');
    var contextInput = closestFields ? closestFields.querySelector('input, textarea, select') : null;
    var context = (contextInput ? contextInput.getAttribute('name') : '') || '';
    context = context.replace(/\[[a-z_]+\]$/, '');

    // If the parent has no inputs we need to strip off the last pair
    var current = content.match(new RegExp('\\[([a-z_]+)\\]\\[new_' + assoc + '\\]'));
    if (current) {
      context = context.replace(new RegExp('\\[' + current[1] + '\\]\\[(new_)?\\d+\\]$'), '');
    }

    // context will be something like this for a brand new form:
    // project[tasks_attributes][1255929127459][assignments_attributes][1255929128105]
    // or for an edit form:
    // project[tasks_attributes][0][assignments_attributes][1]
    if (context) {
      var parentNames = context.match(/[a-z_]+_attributes(?=\]\[(new_)?\d+\])/g) || [];
      var parentIds = context.match(/[0-9]+/g) || [];

      for (var i = 0; i < parentNames.length; i++) {
        if (parentIds[i]) {
          content = content.replace(
            new RegExp('(_' + parentNames[i] + ')_.+?_', 'g'),
            '$1_' + parentIds[i] + '_');

          content = content.replace(
            new RegExp('(\\[' + parentNames[i] + '\\])\\[.+?\\]', 'g'),
            '$1[' + parentIds[i] + ']');
        }
      }
    }

    // Make a unique ID for the new child
    var regexp = new RegExp('new_' + assoc, 'g');
    var new_id = this.newId();
    content = content.replace(regexp, new_id).trim();

    var field = this.insertFields(content, assoc, link);

    // Dispatch custom events
    field.dispatchEvent(new CustomEvent('nested:fieldAdded', { bubbles: true, detail: { field: field } }));
    field.dispatchEvent(new CustomEvent('nested:fieldAdded:' + assoc, { bubbles: true, detail: { field: field } }));

    return false;
  },

  newId: function() {
    return new Date().getTime();
  },

  insertFields: function(content, assoc, link) {
    var target = link.dataset.target;
    var temp = document.createElement('div');
    temp.innerHTML = content;
    var field = temp.firstElementChild;

    if (target) {
      document.querySelector(target).appendChild(field);
    } else {
      link.parentNode.insertBefore(field, link);
    }
    return field;
  },

  removeFields: function(link) {
    var assoc = link.dataset.association; // Name of child to be removed

    var hiddenField = link.previousElementSibling;
    if (hiddenField && hiddenField.type === 'hidden') {
      hiddenField.value = '1';
    }

    var field = link.closest('.fields');
    field.style.display = 'none';

    // Dispatch custom events
    field.dispatchEvent(new CustomEvent('nested:fieldRemoved', { bubbles: true, detail: { field: field } }));
    field.dispatchEvent(new CustomEvent('nested:fieldRemoved:' + assoc, { bubbles: true, detail: { field: field } }));

    return false;
  }
};

window.nestedFormEvents = new NestedFormEvents();

// Event delegation using vanilla JS
document.addEventListener('click', function(e) {
  var addLink = e.target.closest('form a.add_nested_fields');
  if (addLink) {
    e.preventDefault();
    nestedFormEvents.addFields(addLink);
  }

  var removeLink = e.target.closest('form a.remove_nested_fields');
  if (removeLink) {
    e.preventDefault();
    nestedFormEvents.removeFields(removeLink);
  }
});

// Helper function to find closest child (breadth-first search)
// Replaces the jQuery closestChild plugin
window.closestChild = function(element, selector) {
  if (!selector) return null;

  var queue = [element];
  while (queue.length > 0) {
    var node = queue.shift();
    var children = node.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.matches(selector)) {
        return child;
      }
      queue.push(child);
    }
  }
  return null;
};
